import { Base } from "../core/base.model";

export class seguimientosRiesgos extends Base{
    id_seguimiento: number;
    id_riesgo: number;
    valor_probabilidad: number;
    valor_impacto: number;
    probabilidad_ximpacto: string;
    fecha: string;
    resultado: string;
    id_fase_deteccion: number;
    faseDeteccion: string;
    descripcionRiesgo: string;
    causaRaiz: string;
    id_valor_probabilidad: number;
    id_valor_impacto: number;
    id_severidad: number;
    estatusRiesgo: boolean;
    severidadDescripcion: string;
}